import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { GenericModule } from '../generic/generic.module';

import { UploadPreviewFileOperationsComponent } from '@mainrepo/app/standalone-components/upload-preview-file-operations/upload-preview-file-operations.component';
import { AgGridModule } from 'ag-grid-angular';
import { LottieModule } from 'ngx-lottie';
import { AudioclapprComponent } from './audioclappr/audioclappr.component';
import { JioMediaPlayerComponent } from './jio-media-player/jio-media-player.component';
import { PreviewComponent } from './preview/preview.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';



@NgModule({
  declarations: [
    PreviewComponent,
    AudioclapprComponent,
    JioMediaPlayerComponent
  ],
  imports: [
    CommonModule,
    GenericModule,
    LottieModule,
    AgGridModule,
    UploadPreviewFileOperationsComponent,
    PdfJsViewerModule
  ],
  exports:[
    PreviewComponent,
    AudioclapprComponent,
    JioMediaPlayerComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA , NO_ERRORS_SCHEMA]
})
export class PreviewModule { }
